module.exports = __webpack_public_path__ + "static/media/lounge_ageas_coliseu.139b7e4b.webp";